var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 d-flex flex-column mb-3" },
    [
      _c("div", { staticStyle: { flex: "1", "margin-left": "45px" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [_c("section-title", { attrs: { title: _vm.label } })],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row mb-1" },
        _vm._l(_vm.selected, function(item, index) {
          return _c("div", { key: index, staticClass: "col-12" }, [
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                {
                  staticClass: "mb-2",
                  class: {
                    "col-md-9": !_vm.disabled,
                    "col-md-8": _vm.disabled
                  },
                  staticStyle: { height: "38px" }
                },
                [
                  _c("div", { staticClass: "d-flex" }, [
                    _c("div", { staticStyle: { width: "45px" } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-row", staticStyle: { flex: "1" } },
                      [
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(_vm._s(_vm.$t("series.serial")))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control text-right",
                              attrs: { disabled: true },
                              domProps: { value: item.serCode }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("apps.inventory.label.serialnumber")
                                  )
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control text-right",
                              attrs: { disabled: true },
                              domProps: { value: item.serialNumber }
                            })
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-4" }, [
                          _c("div", { staticClass: "input-group" }, [
                            _c("div", { staticClass: "input-group-prepend" }, [
                              _c("span", { staticClass: "input-group-text" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("apps.inventory.label.bin"))
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              staticClass: "form-control text-right",
                              attrs: { disabled: true },
                              domProps: { value: item.binName }
                            })
                          ])
                        ])
                      ]
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-2" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-prepend" }, [
                    _c("span", { staticClass: "input-group-text" }, [
                      _vm._v(_vm._s(_vm.$t("message.quantity")))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control text-right",
                    attrs: { disabled: true },
                    domProps: { value: item.unit }
                  })
                ])
              ])
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { flex: "1", "margin-left": "45px" } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              !_vm.disabled
                ? _c(
                    "BaseButton",
                    {
                      attrs: { disabled: _vm.loading, className: "btn-sm" },
                      on: { click: _vm.onClickOpenModal }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t("apps.inventory.button.selectserialnumber")
                          ) +
                          "\n          "
                      ),
                      _vm.loading
                        ? _c("i", { staticClass: "fas fa-spinner spin" })
                        : _vm._e()
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("BaseSelectSerialNumberModal", {
        attrs: {
          show: _vm.modal.show,
          loading: _vm.modal.loading,
          serials: _vm.serials,
          selected: _vm.selected,
          index: _vm.index,
          skuId: _vm.skuId
        },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal,
          onSortChange: _vm.handleSortChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7075bd68", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7075bd68","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseSelectSerialNumber.vue
// module id = null
// module chunks = 